import { AvailableLanguages, SettingsEntityHydrated } from "@jackfruit/common"
import { select } from "@redux-saga/core/effects"
import { SagaIterator } from "@redux-saga/types"
import { PrinticularApi } from "~/services/PrinticularApi"
import { createPrinticularApi } from "~/services/PrinticularApiProxy"
import { AuthState } from "../state/auth"
import { RootState } from "../store"

export function* getApi(): SagaIterator<PrinticularApi> {
  const settings: SettingsEntityHydrated = yield select(
    (state: RootState) => state.settings.data
  )
  const language: AvailableLanguages = yield select(
    (state: RootState) => state.application.language
  )
  const authState: AuthState = yield select((state: RootState) => state.auth)
  const { remoteApiUrl, remoteApiClientApiKey, deviceToken, recaptchaToken } =
    settings

  let authToken = remoteApiClientApiKey
  if (authState.isAuthenticated) {
    authToken = authState.loginToken
  }

  const printicularApi = createPrinticularApi(
    remoteApiUrl,
    authToken,
    deviceToken,
    language,
    recaptchaToken
  )

  return printicularApi
}
